import meetingArrow from '../../assets/illustrations/arrow_meeting.png';
import assessmentGroup from '../../assets/illustrations/assessment_group.png';
import BuildSurveyQuestionnaireArrow from '../../assets/illustrations/buildSurvey_questionnaire_arrow.svg?react';
import CreateSurveyTemplateArrow from '../../assets/illustrations/createSurvey_template_arrow.svg?react';
import CTAArrow from '../../assets/illustrations/ctaArrow.svg?react';
import DefineAudienceArrow from '../../assets/illustrations/defineAudienceArrow.svg?react';
import Documents from '../../assets/illustrations/documents.svg?react';
import FeedbackResultsArrow from '../../assets/illustrations/feedbackResultsArrow.svg?react';
import ForArrow from '../../assets/illustrations/forArrow.svg?react';
import ForArrowFr from '../../assets/illustrations/forArrowFr.svg?react';
import GrowthPath from '../../assets/illustrations/growthPath.svg?react';
import handoutArrow from '../../assets/illustrations/handout_arrow.png';
import HeaderArrow from '../../assets/illustrations/headerArrow.svg?react';
import HrCycleArrow from '../../assets/illustrations/hr_cycle_arrow.svg?react';
import Ongoing from '../../assets/illustrations/ongoing.svg?react';
import OngoingPastArrow from '../../assets/illustrations/ongoing_past_arrow.svg?react';
import Past from '../../assets/illustrations/past.svg?react';
import PeerReviewToReviewee from '../../assets/illustrations/peerReviewToReviewee.svg?react';
import PeerReviewToRevieweeFr from '../../assets/illustrations/peerReviewToRevieweeFr.svg?react';
import prepareMeetingArrow from '../../assets/illustrations/prepare_meeting_arrow.png';
import Rocket from '../../assets/illustrations/rocket.svg?react';
import ToBeLaunchedOngoingArrow from '../../assets/illustrations/toBeLaunched_ongoing_arrow.svg?react';

interface IllustrationProps {
    /* Optional CSS class for styling */
    className?: string;
}

export const AssessmentGroupIllustration = ({ className }: IllustrationProps) => {
    return (
        <img
            src={assessmentGroup}
            alt={''}
            aria-hidden={'true'}
            width={232}
            height={213}
            className={className}
            data-testid={'assessment-group-illustration'}
        />
    );
};

export const MeetingArrowIllustration = ({ className }: IllustrationProps) => {
    return (
        <img
            src={meetingArrow}
            alt={''}
            aria-hidden={'true'}
            className={className}
        />
    );
};

export const PrepareMeetingArrowIllustration = ({ className }: IllustrationProps) => {
    return (
        <img
            src={prepareMeetingArrow}
            alt={''}
            aria-hidden={'true'}
            className={className}
        />
    );
};

export const HandoutArrowIllustration = ({ className }: IllustrationProps) => {
    return (
        <img
            src={handoutArrow}
            alt={'handout-arrow'}
            aria-hidden={'true'}
            className={className}
            data-testid={'handout-arrow'}
        />
    );
};

export const RocketIllustration = ({ className }: IllustrationProps) => {
    return <Rocket className={className} />;
};

export const DocumentsIllustration = ({ className }: IllustrationProps) => {
    return <Documents className={className} />;
};

export const GrowthPathIllustration = ({ className }: IllustrationProps) => {
    return <GrowthPath className={className} />;
};

export const ForArrowIllustration = ({ className }: IllustrationProps) => {
    return <ForArrow className={className} />;
};

export const ForArrowFrIllustration = ({ className }: IllustrationProps) => {
    return <ForArrowFr className={className} />;
};

export const OngoingIllustration = ({ className }: IllustrationProps) => {
    return <Ongoing className={className} />;
};

export const PastIllustration = ({ className }: IllustrationProps) => {
    return <Past className={className} />;
};

export const OngoingPastArrowIllustration = ({ className }: IllustrationProps) => {
    return <OngoingPastArrow className={className} />;
};

export const ToBeLaunchedOngoingArrowIllustration = ({ className }: IllustrationProps) => {
    return <ToBeLaunchedOngoingArrow className={className} />;
};

export const CreateSurveyTemplateArrowIllustration = ({ className }: IllustrationProps) => {
    return <CreateSurveyTemplateArrow className={className} />;
};

export const BuildSurveyQuestionnaireArrowIllustration = ({ className }: IllustrationProps) => {
    return <BuildSurveyQuestionnaireArrow className={className} />;
};

export const HrCycleArrowIllustration = ({ className }: IllustrationProps) => {
    return <HrCycleArrow className={className} />;
};

export const PeerReviewToRevieweeIllustration = ({ className }: IllustrationProps) => {
    return <PeerReviewToReviewee className={className} />;
};

export const PeerReviewToRevieweeFrIllustration = ({ className }: IllustrationProps) => {
    return <PeerReviewToRevieweeFr className={className} />;
};

export const HeaderArrowIllustration = ({ className }: IllustrationProps) => {
    return <HeaderArrow className={className} />;
};

export const CTAArrowIllustration = ({ className }: IllustrationProps) => {
    return <CTAArrow className={className} />;
};

export const FeedbackResultsArrowIllustration = ({ className }: IllustrationProps) => {
    return <FeedbackResultsArrow className={className} />;
};

export const DefineAudienceArrowIllustration = ({ className }: IllustrationProps) => {
    return <DefineAudienceArrow className={className} />;
};

export const SelectEvaluatorsArrowIllustration = ({ className }: IllustrationProps) => {
    return <DefineAudienceArrow className={className} />;
};
